"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var avatar_enum_1 = __importDefault(require("../../shared/enums/avatar.enum"));
var brand_enum_1 = __importDefault(require("../../shared/enums/brand.enum"));
var icon_enum_1 = __importDefault(require("../../shared/enums/icon.enum"));
var assetImport_1 = __importDefault(require("../../shared/utilities/assetImport"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
var convertToUpperSnakeCase_1 = __importDefault(require("../../shared/utilities/convertToUpperSnakeCase"));
var getIconEnumValue_1 = __importDefault(require("../../shared/utilities/getIconEnumValue"));
var isValidEnum_1 = __importDefault(require("../../shared/utilities/isValidEnum"));
var ImgIcon = react_1.default.memo(function (props) {
    var _a;
    var theme = props.theme;
    // get size
    var getSize = function () { return (0, getIconEnumValue_1.default)(props.size); };
    // extract enum key from pattern (ex: KEY: assets:icons/key.svg)
    var extractEnumKey = function (icon) {
        var match = icon.match(/:[a-z-0-9]+\/([a-z-0-9-_]+)/);
        return (0, convertToUpperSnakeCase_1.default)(match && match.length > 1 ? match[1] : icon);
    };
    var isValidIcon = (0, isValidEnum_1.default)(extractEnumKey(props.icon || ""), icon_enum_1.default, brand_enum_1.default, avatar_enum_1.default);
    return (react_1.default.createElement("img", { alt: (_a = props.alt) !== null && _a !== void 0 ? _a : props.title, src: isValidIcon ? (0, assetImport_1.default)(props.icon, theme) : props.icon, width: getSize(), height: props.squared ? getSize() : undefined, className: (0, classMap_1.default)("mpng-ux-icon mpng-ux-imgicon d-inline-block", props.className), onError: function (e) {
            console.error("Failed to load image: ".concat(props.icon));
            var target = e.target;
            target.style.display = "none";
        } }));
});
exports.default = ImgIcon;
